import { Instance } from 'mobx-state-tree'
import { ApplePaymentSignatureModelBase } from './ApplePaymentSignatureModel.base'

/* The TypeScript type of an instance of ApplePaymentSignatureModel */
export interface ApplePaymentSignatureModelType extends Instance<typeof ApplePaymentSignatureModel.Type> {}

/* A graphql query fragment builders for ApplePaymentSignatureModel */
export {
  selectFromApplePaymentSignature,
  applePaymentSignatureModelPrimitives,
  ApplePaymentSignatureModelSelector
} from './ApplePaymentSignatureModel.base'

/**
 * ApplePaymentSignatureModel
 */
export const ApplePaymentSignatureModel = ApplePaymentSignatureModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
